import { FC, SVGProps } from 'react';

const CustomTagsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4868 4.97239C17.4844 3.79591 16.5949 2.74106 15.4403 2.54241C15.2036 2.50106 12.4266 2.50674 11.2777 2.50754C10.1409 2.50836 9.172 2.917 8.36933 3.71808C6.665 5.41914 4.96233 7.12183 3.26208 8.82616C2.25591 9.83399 2.24208 11.381 3.24425 12.3921C4.68992 13.8515 6.14291 15.3037 7.6015 16.7493C8.61175 17.7507 10.1587 17.7377 11.1674 16.7315C12.8871 15.0166 14.6068 13.3017 16.3193 11.5796C16.9817 10.9132 17.3725 10.108 17.4592 9.16666C17.529 8.41424 17.4884 5.61698 17.4868 4.97239Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.7441 6.9291C11.7473 7.65396 12.353 8.2499 13.0851 8.24827C13.8124 8.24666 14.4181 7.64017 14.414 6.91775C14.4092 6.1637 13.8124 5.57587 13.0535 5.57911C12.3335 5.58155 11.7408 6.19208 11.7441 6.9291Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomTagsIcon;
